import { Directive } from '@angular/core';

/**
 * Directive that styles dialog labels to look like form field labels without using the <label> element and breaking markup.
 *
 * @example
 * <div dialog-label>Label Text</div>
 *
 * @styles /ui/src/styles/ui/mixins/_v2_dialogs.scss
 * - .dialog-label
 */
@Directive({
    selector: '[dialog-label], dialog-label, [dialogLabel]',
    host: {class: 'dialog-label'},
    standalone: true
})
export class DialogLabelDirective
{
}

/**
 * Directive that styles dialog section headers within the mat-dialog-content element.
 *
 * @example
 * <h4 dialog-section-header>Section Header</h4>
 *
 * @styles /ui/src/styles/ui/mixins/_v2_dialogs.scss
 * - .dialog-section-header
 */
@Directive({
    selector: 'h4[dialogSectionHeader]',
    standalone: true,
    host: { class: 'dialog-section-header' },
})
export class DialogSectionHeaderDirective
{
}

/**
 * Directive that styles disclosure statement text within mat-dialog-content.
 *
 * @example
 * <p dialogDisclosureStatement>PayHOA partners with...</p>
 *
 * @styles /ui/src/styles/ui/mixins/_v2_dialogs.scss
 * - .disclosure-statement
 */
@Directive({
    selector: '[dialogDisclosureStatement]',
    standalone: true,
    host: { class: 'disclosure-statement' },
})
export class DialogDisclosureStatementDirective
{
}

/**
 * Directive that resets unordered/ordered list styles within dialogs to default styling.
 *
 * @example
 * <ul dialogList>
 *     <li>Item one</li>
 *     <li>Item two</li>
 * </ul>
 *
 * @styles /ui/src/styles/ui/mixins/_v2_dialogs.scss
 * - .dialog-list
 */
@Directive({
    selector: 'ul[dialogList], ol[dialogList]',
    standalone: true,
    host: { class: 'dialog-list' },
})
export class DialogListDirective
{
}
